<div>
    <app-ativacao-section-card
        [control]="ativacaoControl"
        titulo="Tributação Monofásica"
        descricaoAtivo="Tributação Monofásica ativa. As alíquotas por unidade abaixo serão aplicadas no cálculo desta regra tributária."
        descricaoInativo="Tributação Monofásica inativa. Esta regra tributária não aplica tributação monofásica."
        emptyStateTitulo="Tributação Monofásica desativada"
        emptyStateDescricao="Ative a Tributação Monofásica acima para configurar as modalidades padrão, retenção, retida anteriormente e diferimento.">
    </app-ativacao-section-card>

    @if (ativacaoControl.value) {
    <app-regra-tributaria-mono-padrao-section [form]="padraoForm" [formulas]="formulas"></app-regra-tributaria-mono-padrao-section>
    <app-regra-tributaria-mono-retencao-section [form]="retencaoForm" [formulas]="formulasRetencao"></app-regra-tributaria-mono-retencao-section>
    <app-regra-tributaria-mono-retida-section [form]="retidaAntForm" [formulas]="formulasRetida"></app-regra-tributaria-mono-retida-section>
    <app-regra-tributaria-mono-diferimento-section [form]="diferimentoForm" [formulas]="formulasDiferimento"></app-regra-tributaria-mono-diferimento-section>
    }
</div>
